import type { Module } from 'vuex'
import type { StoreState } from '../store-state'

/** 자동 로그인 정보 — 일렉트론이 IPC 로 넣어 준다 */
export type AutoLoginState = {
    id: string
    password: string
    isAutoLogin: boolean
}

const state: AutoLoginState = {
    id: '',
    password: '',
    isAutoLogin: true,
}

type Store = { commit(type: string, payload: unknown): void }

const actions = {
    'AC_SetLoginInfo': async (store: Store, param: Partial<AutoLoginState>): Promise<void> => {
        store.commit('MU_SetLoginInfo', param)
    },
}

const mutations = {
    /** 넘어온 것만 갈아끼운다 */
    'MU_SetLoginInfo': (state: AutoLoginState, param: Partial<AutoLoginState>): void => {
        Object.assign(state, param)
    },
}

const autoLogin: Module<AutoLoginState, StoreState> = { state, actions, mutations }

export default autoLogin
